import React from 'react';
import '../../../styles/modes/compareMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Compare Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Compare algorithm-generated TSP tours with manually created tours to evaluate routing efficiency and learn optimization techniques.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Tour created in Auto Find Path Mode</li>
            <li>Tour created in Custom Path Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Create Both Tours:</strong>
              <ul>
                <li>Go to Auto Find Path Mode and generate optimal tour</li>
                <li>Go to Custom Path Mode and create your own tour</li>
                <li>Both tours automatically saved</li>
              </ul>
            </li>
            <li><strong>View Comparison:</strong>
              <ul>
                <li>Switch to Compare Mode</li>
                <li>Both tours displayed on map simultaneously</li>
                <li>Different colors for easy distinction</li>
              </ul>
            </li>
            <li><strong>Review Tour Information:</strong>
              <ul>
                <li><strong>Auto Path:</strong> Algorithm solution with total distance and sequence</li>
                <li><strong>Custom Path:</strong> Manual solution with total distance and sequence</li>
              </ul>
            </li>
            <li><strong>Analyze Results:</strong>
              <ul>
                <li><strong>Distance Difference:</strong> Shows km saved or added</li>
                <li><strong>Percentage Difference:</strong> Efficiency gap between solutions</li>
                <li><strong>Conclusion:</strong> Which tour is more efficient</li>
              </ul>
            </li>
            <li><strong>Detailed Comparison (Optional):</strong>
              <ul>
                <li>Click "Show Detailed Comparison"</li>
                <li>Segment-by-segment distance breakdown</li>
                <li>Optimization suggestions</li>
                <li>Identify specific inefficient segments</li>
              </ul>
            </li>
          </ol>

          <p><strong>Comparison Metrics:</strong></p>
          <ul>
            <li><strong>Total Distance:</strong> Complete tour length in kilometers</li>
            <li><strong>Point Count:</strong> Number of locations visited</li>
            <li><strong>Distance Difference:</strong> Absolute difference in km</li>
            <li><strong>Percentage Difference:</strong> Relative efficiency gap</li>
          </ul>

          <p><strong>Interpretation:</strong></p>
          <ul>
            <li><strong>"Saved X km":</strong> Custom tour is shorter (good manual planning!)</li>
            <li><strong>"Extra X km":</strong> Auto tour is shorter (algorithm found better route)</li>
            <li><strong>Percentage:</strong> Shows magnitude of difference</li>
          </ul>

          <p><strong>Learning from Comparison:</strong></p>
          <ul>
            <li><strong>Routing Patterns:</strong> Identify efficient visiting sequences</li>
            <li><strong>Common Mistakes:</strong> Spot path crossings and detours</li>
            <li><strong>Algorithm Insights:</strong> Learn how optimization works</li>
            <li><strong>Improvement Strategies:</strong> Apply lessons to future manual tours</li>
          </ul>

          <p><strong>Use Cases:</strong></p>
          <ul>
            <li>Validate algorithm solutions against domain knowledge</li>
            <li>Learn TSP optimization principles</li>
            <li>Identify manual routing mistakes</li>
            <li>Improve tour planning skills</li>
            <li>Educational tool for understanding TSP algorithms</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Both tours must be complete before comparison works</li>
            <li>Use detailed comparison to understand specific differences</li>
            <li>Try recreating custom tour to beat algorithm</li>
            <li>Look for patterns in algorithm solutions</li>
            <li>Small percentage differences indicate good manual planning</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 